module.exports = __webpack_public_path__ + "static/media/doctor_mock.e13691d2.svg";